import _ from "lodash";
import app_math from "./math.js";
import superconsole from "./superconsole.js";

export default {
  blend_operation: function (target, defdata, source, prop, type) {
    if (defdata == null) throw "Operation set as blend, and data default is not set!";
    if (_.isArray(target)) {
      if (!_.isArray(defdata)) throw "Operation set as blend, target is array and default data is not array - " + prop;
      target.length = 0;
      target.push(..._.cloneDeep(defdata));
      if (source != null && source[prop + "_" + type] != null) {
        if (!_.isArray(source[prop + "_" + type]))
          throw "Operation set as blend, data default is array and source is not array - " + prop;
        for (let cnt = 0; cnt < target.length; cnt++) {
          if (source[prop + "_" + type][cnt] != null) {
            this.$set(target, cnt, _.cloneDeep(source[prop + "_" + type][cnt]));
            // target[cnt] = _.cloneDeep(source[prop + "_" + type][cnt]);
          }
        }
      }
    } else if (_.isPlainObject(target)) {
      if (!_.isPlainObject(defdata))
        throw "Operation set as blend, target is object and default data is not object - " + prop;
      this.assign(target, _.cloneDeep(defdata));
      if (source != null && source[prop + "_" + type] != null) {
        if (!_.isPlainObject(source[prop + "_" + type]))
          throw "Operation set as blend, data default is object and source is not object - " + prop;
        for (let key of Object.keys(target)) {
          if (source[prop + "_" + type][key] != null) {
            this.$set(target, key, _.cloneDeep(source[prop + "_" + type][key]));
            // target[key] = _.cloneDeep(source[prop + "_" + type][key]);
          }
        }
      }
    } else {
      throw "Operation set as blend, and target is not object and not array - " + prop;
    }
  },
  assign: function (target, source) {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        this.$set(target, key, source[key]);
      }
    }
  },
  overwrite_operation: function (target, defdata, source, prop, type) {
    if (defdata == null) throw "Operation set as overwrite, and data default is not set - " + prop;
    if (_.isArray(target)) {
      if (!_.isArray(defdata))
        throw "Operation set as overwrite, target is array and default data is not array - " + prop;
      target.length = 0;
      target.push(..._.cloneDeep(defdata));
      if (source != null && source[prop + "_" + type] != null) {
        if (!_.isArray(source[prop + "_" + type]))
          throw "Operation set as overwrite, data default is array and source is not array - " + prop;
        for (let cnt = 0; cnt < source[prop + "_" + type].length; cnt++) {
          this.$set(target, cnt, _.cloneDeep(source[prop + "_" + type][cnt]));
          // target[cnt] = _.cloneDeep(source[prop + "_" + type][cnt]);
        }
      }
    } else if (_.isPlainObject(target)) {
      if (!_.isPlainObject(defdata))
        throw "Operation set as overwrite, target is object and default data is not object - " + prop;
      this.assign(target, _.cloneDeep(defdata));
      if (source != null && source[prop + "_" + type] != null) {
        if (!_.isPlainObject(source[prop + "_" + type]))
          throw "Operation set as overwrite, data default is object and source is not object - " + prop;
        for (let key of Object.keys(source[prop + "_" + type])) {
          this.$set(target, key, _.cloneDeep(source[prop + "_" + type][key]));
          // target[key] = _.cloneDeep(source[prop + "_" + type][key]);
        }
      }
    } else {
      throw "Operation set as overwrite, and target is not object and not array - " + prop;
    }
  },
  get_source_data: function (source, value, prop, type) {
    if (source === "city") {
      if (this.city[value] != null && this.city[value][prop + "_" + type] != null) {
        return _.cloneDeep(this.city[value][prop + "_" + type]);
      } else if (
        this.country[this.data.loc_country.value] != null &&
        this.country[this.data.loc_country.value][prop + "_" + type] != null
      ) {
        return _.cloneDeep(this.country[this.data.loc_country.value][prop + "_" + type]);
      } else {
        return _.cloneDeep(this.data[prop][type + "_default"]);
      }
    } else {
      if (this[source][value] != null && this[source][value][prop + "_" + type] != null) {
        return _.cloneDeep(this[source][value][prop + "_" + type]);
      } else if (
        source === "language" &&
        this[source].default != null &&
        this[source].default[prop + "_" + type] != null
      ) {
        return _.cloneDeep(this[source].default[prop + "_" + type]);
      } else {
        return _.cloneDeep(this.data[prop][type + "_default"]);
      }
    }
  },
  process_property: function (obj, name, value, prop, propname) {
    if (name !== "title" && name !== "select" && name !== "data" && name !== "data_select" && name !== "images")
      throw "Invalid process property name. Has to be title, select, data, images or data_select";
    if (obj[name] != null) {
      let trigger = "";
      if (propname) {
        trigger = obj[name + "_trigger"];
        if (!trigger || trigger !== propname) return false;
      }
      let source = "";
      if (name === "title" || name === "select") {
        source = "language";
      } else if (trigger === "loc_country_value") {
        source = "country";
      } else if (trigger === "app_residence_value") {
        source = "residence";
      } else if (trigger === "loc_city_value") {
        source = "city";
      } else {
        throw "Invalid trigger name. Has to be loc_country_value, app_residence_value or loc_city_value";
      }
      if (obj[name + "_operation"] == null || obj[name + "_operation"] === "replace") {
        // eslint-disable-next-line
        superconsole.log("replace", source, value, prop, name);
        obj[name] = this.get_source_data(source, value, prop, name);
      } else {
        let defdata;
        if (source === "language" && this[source].default != null && this[source].default[prop + "_" + name] != null) {
          defdata = this[source].default[prop + "_" + name];
        } else {
          defdata = obj[name + "_default"];
        }
        if (obj[name + "_operation"] === "blend") {
          // eslint-disable-next-line
          superconsole.log("blend", source, value, prop, name);

          this.blend_operation(obj[name], defdata, this[source][value], prop, name);
        } else if (obj[name + "_operation"] === "overwrite") {
          // eslint-disable-next-line
          superconsole.log("overwrite", source, value, prop, name);
          this.overwrite_operation(obj[name], defdata, this[source][value], prop, name);
        }
      }

      return true;
    }

    return false;
  },
  set_value: function (name, value, prop, obj, loaded, newimg) {
    // name je string iz triggera -- loc_country_value
    const processed = this.process_property(obj, "data", value, prop, name);
    this.process_property(obj, "data_select", value, prop, name);
    this.process_property(obj, "images", value, prop, name);
    if (loaded != null && newimg != null && obj.images != null) {
      let objimg;
      if (_.isArray(obj.images)) {
        objimg = new Set([...obj.images]);
      } else if (_.isPlainObject(obj.images)) {
        objimg = new Set([...Object.values(obj.images)]);
      } else if (typeof obj.images === "string") {
        objimg = new Set([obj.images]);
      } else {
        throw "Object images not array, not object and not string";
      }
      for (const elem of objimg) {
        if (loaded.indexOf(elem) === -1) {
          newimg.add(elem);
        }
      }
    }

    if (processed && obj.source === "computed" && obj.hasOwnProperty("data_value")) {
      if (!obj.hasOwnProperty("data")) {
        throw "Object source set as computed, data_value set and data not set!";
      } else {
        if (_.isArray(obj.data)) {
          if (!obj.data.length) {
            // eslint-disable-next-line no-console
            console.warn("Object data_value set and data is empty array!");
          }
          if (obj.data_value === "first") {
            obj.value = obj.data[0];
          } else if (obj.data_value === "middle") {
            obj.value = obj.data[app_math.middle(obj.data.length)];
          } else {
            if (obj.data.indexOf(obj.data_value) === -1) {
              throw "Object data_value set and data does not contain data_value!";
            }
            obj.value = obj.data_value;
          }
        } else if (_.isPlainObject(obj.data)) {
          let keys = Object.keys(obj.data);
          if (!keys.length) {
            // eslint-disable-next-line no-console
            console.warn("Object data_value set and data is empty object!");
          }
          if (obj.data_value === "first") {
            obj.value = keys[0];
          } else if (obj.data_value === "middle") {
            obj.value = keys[app_math.middle(keys.length)];
          } else {
            if (keys.indexOf(obj.data_value) === -1) {
              throw "Object data_value set and data does not contain data_value!";
            }
            obj.value = obj.data_value;
          }
        } else if (obj.data_value === "copy") {
          obj.value = obj.data;
        } else {
          throw "Object data_value set and data is not array and not object!";
        }
      }
    }
  },
  set_props: function (target, name, value, loaded, newimg) {
    for (const prop of Object.keys(target)) {
      let obj = this.data[prop];
      this.set_value(name, value, prop, obj, loaded, newimg);
    }
  },
  generate_guid: function () {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
  },
  check_mobile: function () {
    // const a = navigator.userAgent || navigator.vendor || window.opera;
    // if (
    //   /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    //     a
    //   ) ||
    //   /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
    //     a.substr(0, 4)
    //   )
    // ) {
    //   return true;
    // }
    // return false;
    // if (window.innerHeight > window.innerWidth) {
    //   return true;
    // } else {
    //   return window.innerWidth < 800;
    // }
    if (window.orientation == null) {
      return false;
    } else if (window.orientation == 0 || window.orientation == 180) {
      return true;
    } else {
      return Math.max(window.innerWidth, window.innerHeight) < 800;
    }
  },
  get_top_sklop_data: function (app_sklopovi_data, top_image, top_debljina_zida, top_debljina_izolacije_default) {
    if (top_image === "no_data") {
      return {
        u: 3,
        laka_konstrukcija: false,
        tip_prozora: 0,
      };
    }

    let sklop = null;
    let final_u = -1;
    if (app_sklopovi_data[top_image + "_" + top_debljina_zida + "_" + top_debljina_izolacije_default]) {
      sklop = app_sklopovi_data[top_image + "_" + top_debljina_zida + "_" + top_debljina_izolacije_default];
      final_u = sklop.u;
    } else if (top_debljina_izolacije_default === 1 && app_sklopovi_data[top_image + "_" + top_debljina_zida + "_0"]) {
      sklop = app_sklopovi_data[top_image + "_" + top_debljina_zida + "_0"];
      final_u = app_math.get_final_existing_U(sklop.u, 0, 0.01);
    } else {
      sklop = app_sklopovi_data[top_image + "_" + top_debljina_zida] || app_sklopovi_data[top_image] || {};
      final_u = sklop.u;
    }

    return {
      u: final_u || -1,
      laka_konstrukcija: sklop.laka_konstrukcija || false,
      tip_prozora: sklop.tip_prozora || 0,
    };
  },
  get_bottom_sklop_data: function (app_sklopovi_data, bottom_image) {
    if (bottom_image === "no_data") {
      return {
        u: 3,
        laka_konstrukcija: false,
        tip_prozora: 0,
      };
    }
    const sklop = app_sklopovi_data[bottom_image] || {};
    return {
      u: sklop.u || -1,
      laka_konstrukcija: sklop.laka_konstrukcija || false,
      tip_prozora: sklop.tip_prozora || 0,
    };
  },
  get_default_sklop: function (
    typ_stanje_value,
    app_sklopovi_default_data,
    current_position,
    typ_constdate_value,
    get_sklopovi_data_sklopovi,
    typ_ceiling_value,
    loc_country_value
  ) {
    const defdata =
      typ_stanje_value === 2
        ? app_sklopovi_default_data[loc_country_value + "_new_house_" + current_position]
        : app_sklopovi_default_data[typ_constdate_value + "_" + current_position];
    if (defdata) {
      const split_defdata = defdata.split("_");
      if (current_position == 18 && typ_ceiling_value == 2) {
        split_defdata[1] = +split_defdata[1] + 100;
      }
      return {
        image: "_" + split_defdata[0] + "_" + split_defdata[1],
        debljina_zida: split_defdata[2] || 0,
        debljina_izolacije: split_defdata[3] || 0,
        debljina_izolacije_default: split_defdata[3] || 0,
      };
    } else {
      if (get_sklopovi_data_sklopovi[current_position] && get_sklopovi_data_sklopovi[current_position].length) {
        return { image: get_sklopovi_data_sklopovi[current_position][0] };
      } else {
        return { image: "no-data" };
      }
    }
  },
  get_default_status_data: function (
    typ_stanje_value,
    app_sklopovi_default_data,
    current_position,
    typ_constdate_value,
    get_sklopovi_data,
    app_sklopovi_data,
    typ_ceiling_value,
    loc_country_value,
    app_sklopovi_a_data
  ) {
    const status = {};
    const sklop_default = this.get_default_sklop(
      typ_stanje_value,
      app_sklopovi_default_data,
      current_position,
      typ_constdate_value,
      get_sklopovi_data.sklopovi,
      typ_ceiling_value,
      loc_country_value
    );

    const termoizolacija = app_sklopovi_a_data[sklop_default.image].ima_termoizolaciju;
    status.top_image = sklop_default.image;
    status.top_debljina_zida_full = sklop_default.debljina_zida;
    status.top_debljina_zida = app_math.round(status.top_debljina_zida_full / 100, 2);
    status.top_debljina_izolacije_default_full =
      sklop_default.debljina_izolacije_default != 0 ? sklop_default.debljina_izolacije_default : termoizolacija ? 1 : 0;
    status.top_debljina_izolacije_default = app_math.round(status.top_debljina_izolacije_default_full / 100, 2);
    status.top_debljina_izolacije_full = status.top_debljina_izolacije_default_full;
    status.top_debljina_izolacije = status.top_debljina_izolacije_default;

    const top_sklop = this.get_top_sklop_data(
      app_sklopovi_data,
      status.top_image,
      status.top_debljina_zida_full,
      status.top_debljina_izolacije_default_full
    );
    status.laka_konstrukcija = top_sklop.laka_konstrukcija;
    status.tip_prozora = top_sklop.tip_prozora;
    return status;
  },
  get_top_debljina_zida: function (get_sklopovi_data, top_image) {
    return get_sklopovi_data.debljina_zida[top_image] ? get_sklopovi_data.debljina_zida[top_image][0] || 0 : 0;
  },
  get_top_debljina_izolacije: function (app_sklopovi_a_data, get_sklopovi_data, top_image, top_debljina_zida) {
    return app_sklopovi_a_data[top_image].ima_termoizolaciju
      ? get_sklopovi_data.debljina_izolacije[top_image + "_" + top_debljina_zida] || 1
      : 0;
  },
  get_position_type: function (current_position) {
    if (current_position == "10" || current_position == "13" || current_position == "60") {
      return 2;
    } else if (current_position == "20" || current_position == "21") {
      return 3;
    } else {
      return 1;
    }
  },
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
};
